import React from 'react';
import './App.css';
import './scss/app.scss';
import { useSelector } from 'react-redux';
import Progress from './features/progress/Progress';
import Footer from './common/components/navigation/Footer';
import Form from './features/quote/Form';
import Header from './common/components/navigation/Header';
import StickyFooter from './common/components/navigation/StickyFooter';
import { getQuote } from './features/quote/QuoteSlice';

export interface StepObject {
    step: number;
    innerStep: number;
}

function App() {
  const quoteData = useSelector(getQuote);

  return (
    <div className="App">
      <Header />
      {!window.kbSchema.is_offline_referral && <Progress stepObject={quoteData.step} />}
      <Form />
      {quoteData.step.step === 0
        && <StickyFooter />}
      <Footer />
    </div>
  );
}

export default App;
